module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 function player(player, reverse, round){ 
__p+='\n	<div class="player-cell">\n		';
 if(!reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n			</figure>\n		';
 } 
__p+='\n		<div class="player-info">\n			<div class="player-name">\n				<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="player-stats">\n				<span class="player-opponent">\n					<b class="desktop-only">'+
((__t=( _.result(squad_by_id[player.squad_id], 'full_name') ))==null?'':_.escape(__t))+
'</b>\n					<b class="mobile-only">'+
((__t=( _.result(squad_by_id[player.squad_id], 'short_name') ))==null?'':_.escape(__t))+
'</b>\n				</span>\n				<span> | </span>\n				<span class="player-positions">\n					'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n				</span>\n				<br>\n				<span class="player-cost">\n					'+
((__t=( _.currencyFormat(_.result(player.stats.prices, round, player.cost)) ))==null?'':_.escape(__t))+
'\n				</span>\n			</div>\n		</div>\n		';
 if(reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n			</figure>\n		';
 } 
__p+='\n	</div>\n';
 } 
__p+='\n\n<div class="trade-history-container">\n	';
 if(_.size(rounds)){ 
__p+='\n		<h4>Trade history</h4>\n	';
 } 
__p+='\n\n	';
 _.each(rounds, function(round){ 
__p+='\n		<div class="round">\n			<div class="round-header">\n				<h5 class="round-header-title">ROUND '+
((__t=( round ))==null?'':_.escape(__t))+
'</h5>\n\n				';
 if(history[round]){ 
__p+='\n					<h5 class="round-header-trades">Trades Remaining : '+
((__t=( remaining_trades[round] ))==null?'':_.escape(__t))+
'</h5>\n				';
 } 
__p+='\n			</div>\n			';
 if(history[round]){
				_.each(history[round], function(trade){ 
__p+='\n					<div class="trade-item">\n						<div class="trade-item-player trade-item-out-player">\n							';
 player(players_by_id[trade.new_player], false, round) 
__p+='\n						</div>\n						<div class="trade-item-middle-icon">\n							<img src="/assets/images/trade-icon.png" alt="">\n						</div>\n						<div class="trade-item-player trade-item-in-player">\n							';
 player(players_by_id[trade.old_player], true, round) 
__p+='\n						</div>\n					</div>\n				';
 })
			} else { 
__p+='\n				<p class="no-trade-text">No trades made</p>\n			';
 } 
__p+='\n		</div>\n	';
 }) 
__p+='\n</div>\n\n';
}
return __p;
};
